import React, {Component} from 'react';

// router
import { BrowserRouter as Router, Route, Redirect, Switch } from 'react-router-dom';

// views
import HomeView from '../views/homeView/homeView';
import AddTabView from '../views/addTabView/addTabView';
import RequestTabView from '../views/requestTabView/requestTabView';
import LoginPageView from '../views/loginPageView/loginPageView';
import RegisterPageView from '../views/registerPageView/registerPageView';
import AccountSettingsView from '../views/accountSettingsView/accountSettingsView';
import MyTabsView from '../views/myTabsView/myTabsView';
import ContactView from '../views/contactView/contactView';
import TermsView from '../views/termsView/termsView';
import TabView from '../views/tabView/tabView';
import ArtistView from '../views/artistView/artistView';
import ArtistsView from '../views/artistsView/artistsView';
import NotFoundView from '../views/notFoundView/notFoundView';

import CookieConsent from "react-cookie-consent";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//
// other stuff
import CONST from '../util/const';

import Header from '../views/headerView/headerView';
import Footer from '../views/footerView/footerView';
import Sidebar from '../components/sidebar/sidebar';

const AppAuth = {
  isAuthenticated: localStorage.getItem('token') ? true : false
}

class Main extends Component {

  GetContent = (Component = 'div', active) => {

    return (props) => (
  
      <div style={{ height: 'inherit' }}>
        <Header authenticated={AppAuth.isAuthenticated} active={active}  />
        <div className="main-content">
          <Component {...props}/>
        </div>
        <Sidebar />
        <Footer />
        <CookieConsent
              location="bottom"
              buttonText="Sunt de acord!"
              cookieName="cookieConsent1"
              style={{ background: "#2B373B" }}
              buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
              expires={150}
          >
              Acest sit web folosește <FontAwesomeIcon icon="cookie" /> cookies (prăjiturele) pentru a face experiența ta mai faină.{" "}
              <span style={{ fontSize: "10px" }}>
              Serios, e dreptul tău la informare, așa că dacă vrei să afli mai multe poți să o faci <a target="_blank" style={{color:'#fed149', textDecoration: 'none'}} href="https://ro.wikipedia.org/wiki/Cookie">AICI</a>.
              </span>
          </CookieConsent>
      </div>
    );
  };

  render(){
    return (
      <Router>
          <div style={{height: 'inherit'}}>

              <Switch>
                <Route exact path="/" component={ this.GetContent(HomeView, CONST.navigation.home) }/>
                <Route exact path="/autentificare" component={ this.GetContent(LoginPageView, CONST.navigation.login) }/>
                <Route exact path="/cont-nou" component={ this.GetContent(RegisterPageView, CONST.navigation.register) }/>
                <Route exact path="/contact" component={ this.GetContent(ContactView, CONST.navigation.contact) }/>
                <Route exact path="/termeni-si-conditii" component={ this.GetContent(TermsView, CONST.navigation.terms) }/>
                <Route exact path="/tabulatura/:id/:artist?/:title?" component={ this.GetContent(TabView, CONST.navigation.tab) }/>
                <Route exact path="/artist/:slug" component={ this.GetContent(ArtistView, CONST.navigation.artist) }/>
                <Route exact path="/artisti/:letter" component={ this.GetContent(ArtistsView, CONST.navigation.artist) }/>
                {/* PRIVATE ROUTES */}
                <PrivateRoute path="/adauga-tabulatura" component={ this.GetContent(AddTabView, CONST.navigation.addTab) } />
                <PrivateRoute path="/cere-tabulatura" component={ this.GetContent(RequestTabView, CONST.navigation.askTab) } />
                <PrivateRoute path="/setari-cont" component={ this.GetContent(AccountSettingsView, CONST.navigation.accountSettings) } />
                <PrivateRoute path="/tabulaturile-mele" component={ this.GetContent(MyTabsView, CONST.navigation.myTabs) } />
                <Route component={ this.GetContent(NotFoundView, CONST.navigation.notFound) } status={404} />
              </Switch>
          </div>
      </Router>
    );
  }
}

const PrivateRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props =>
        AppAuth.isAuthenticated ? (
          <Component {...props} />
        ) : (
          localStorage.setItem('intended', props.location.pathname),
          <Redirect
            to={{
              pathname: "/autentificare",
              state: { from: props.location }
            }}
          />
        )
      }
    />
  );
};

export default Main;



// WEBPACK FOOTER //
// ./src/components/main.js